// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__NrlCb","content":"LoadingAlert_content__1t9jr"};